import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, TournamentDeleteRequest, TournamentGetListRequest, TournamentGetListResponse, TournamentInsertRequest } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TournamentService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllTournaments(body: TournamentGetListRequest) {
    const link = this.apiUrl + ApiUrls.getTournaments;
    return this.http.post<TournamentGetListResponse>(link, body);
  }

  getTournament(id: any) {
    const link = this.apiUrl + ApiUrls.getTournament;
    return this.http.get<any>(link+"/"+ id );
  }

  deleteTournament(body: TournamentDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteTournament;
    return this.http.post<BaseResponse>(link, body);
  }

  insertTournament(body: TournamentInsertRequest) {
    const link = this.apiUrl + ApiUrls.insertTournament;
    return this.http.post<BaseResponse>(link, body);
  }
  updateTournament(body: TournamentInsertRequest) {
    const link = this.apiUrl + ApiUrls.updateTournament;
    return this.http.post<BaseResponse>(link, body);
  }
}
